function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import classNames from 'classnames';
import { Formik } from 'formik';
import get from 'lodash/fp/get';
import identity from 'lodash/fp/identity';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as yup from 'yup';
import { hideModal, registerProjectTrialMembers, showModal } from '../../../redux/actions';
import routes from '../../../routes/constants';
import text from '../../../text';
import Button from '../../button/Button';
import Control from '../../form/Control';
import Icon from '../../icon/Icon';
import { PROJECT_TRIAL_MEMBERS_SUCCESS_MODAL } from './ProjectTrialMembersSuccess';
export var PROJECT_TRIAL_MEMBERS_MODAL = 'PROJECT_TRIAL_MEMBERS_MODAL';
export var usersSchema = yup.object({
    users: yup.array().test('is-users', identity, function(value) {
        var emailSchema = yup.string().email(text('enterValidEmail')).required();
        return value.every(function(v) {
            return v.email;
        }) ? value.every(function(v) {
            return emailSchema.isValidSync(v.email);
        }) : value.some(function(v) {
            return emailSchema.isValidSync(v.email);
        });
    })
});
var FEATURES = [
    {
        icon: '2d-map',
        text: text('trialFeature2D')
    },
    {
        icon: 'file',
        text: text('trialFeatureFileManager')
    },
    {
        icon: '3D',
        text: text('trialFeature3D')
    }
];
var DATA_FEATURES = [
    {
        icon: 'streetscape',
        text: text('streetscapePointCloudDescription'),
        iconClassName: 'streetscape enabled'
    },
    {
        icon: 'aerial',
        text: text('aerialPointCloudDescription'),
        iconClassName: 'aerial enabled'
    }
];
var ProjectTrialMembersModal = function(param) {
    var show = param.show, projectId = param.projectId;
    var dispatch = useDispatch();
    var history = useHistory();
    var handleHide = function() {
        return dispatch(hideModal(PROJECT_TRIAL_MEMBERS_MODAL));
    };
    var handleClick = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(values) {
            var users;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        users = values.users.filter(function(u) {
                            return u.email;
                        });
                        return [
                            4,
                            dispatch(registerProjectTrialMembers(projectId, users))
                        ];
                    case 1:
                        _state.sent();
                        console.assert(projectId, 'Opps! projectId is empty or undefined');
                        dispatch(showModal(PROJECT_TRIAL_MEMBERS_SUCCESS_MODAL, {
                            projectId: projectId
                        }));
                        history.push(routes.dashboard);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleClick(values) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ React.createElement(Modal, {
        centered: true,
        className: "ProjectTrialMemberModal",
        contentClassName: "w-auto px-4",
        show: show,
        onHide: handleHide
    }, /*#__PURE__*/ React.createElement(Modal.Body, {
        className: "centered"
    }, /*#__PURE__*/ React.createElement("h3", {
        className: "mb-1"
    }, text('projectTrial3Users3Months')), /*#__PURE__*/ React.createElement("p", null, text('projectTrialCongratulationsAccess')), /*#__PURE__*/ React.createElement("h5", {
        className: "mb-1"
    }, text('measureCollaboratePlatform')), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 center-content"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "p-0 d-flex flex-column align-items-start"
    }, FEATURES.map(function(param, i) {
        var _$text = param.text, iconClassName = param.iconClassName, icon = param.icon;
        return /*#__PURE__*/ React.createElement("li", {
            key: i,
            className: "my-1 center-content"
        }, /*#__PURE__*/ React.createElement(Icon, {
            className: classNames('mr-3 framed outline-primary', _define_property({}, iconClassName, iconClassName)),
            icon: icon
        }), /*#__PURE__*/ React.createElement("h6", null, _$text));
    }))), /*#__PURE__*/ React.createElement("h5", {
        className: "m-2"
    }, text('getProjectTrialFreeData')), /*#__PURE__*/ React.createElement("div", {
        className: "mb-3 center-content"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "p-0 d-flex flex-column align-items-start"
    }, DATA_FEATURES.map(function(param, i) {
        var _$text = param.text, iconClassName = param.iconClassName, icon = param.icon;
        return /*#__PURE__*/ React.createElement("li", {
            key: i,
            className: "my-1 center-content"
        }, /*#__PURE__*/ React.createElement(Icon, {
            className: classNames('mr-3 framed outline-primary', _define_property({}, iconClassName, iconClassName)),
            icon: icon
        }), /*#__PURE__*/ React.createElement("h6", null, _$text));
    }))), /*#__PURE__*/ React.createElement(Formik, {
        initialValues: {
            users: [
                {
                    email: undefined
                },
                {
                    email: undefined
                }
            ]
        },
        onSubmit: handleClick,
        validationSchema: usersSchema,
        isInitialValid: false
    }, function(param) {
        var values = param.values, touched = param.touched, errors = param.errors, isValid = param.isValid, isSubmitting = param.isSubmitting, handleSubmit = param.handleSubmit, setFieldTouched = param.setFieldTouched, setFieldValue = param.setFieldValue;
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Modal.Body, {
            className: "p-0"
        }, /*#__PURE__*/ React.createElement("h5", null, text('shareWithTheseUsers')), /*#__PURE__*/ React.createElement(React.Fragment, null, values.users.map(function(user, i) {
            return /*#__PURE__*/ React.createElement("div", {
                key: i,
                className: "center-content w-100"
            }, text('projectUserNumber', {
                email: '',
                number: i + 1
            }), /*#__PURE__*/ React.createElement(Control, {
                className: "ml-2",
                required: true,
                as: "input",
                type: "text",
                name: "users.".concat(i, ".email"),
                value: user.email,
                onBlur: function() {
                    return setFieldTouched("users.".concat(i, ".email"), true);
                },
                onChange: function(event) {
                    return setFieldValue("users.".concat(i, ".email"), event.target.value);
                },
                isFailed: get("users.".concat(i, ".email"), touched) && get("users.".concat(i, ".email"), errors),
                validationError: get("users.".concat(i, ".email"), errors)
            }));
        }))), /*#__PURE__*/ React.createElement(Modal.Footer, {
            className: "center-content"
        }, /*#__PURE__*/ React.createElement(Button, {
            variant: "link",
            onClick: handleHide
        }, text('maybeLater')), /*#__PURE__*/ React.createElement(Button, {
            disabled: !isValid,
            loading: isSubmitting,
            onClick: handleSubmit
        }, text('sharePlatform'))));
    })));
};
export default ProjectTrialMembersModal;
